import { Injectable } from '@angular/core';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { DataService } from 'app/shared/services/data.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IDtoRequisition } from 'app/shared/models/opening/dto-requisition.model';
import { IResult } from 'app/shared/models/result.model';
import { ISelect } from 'app/shared/models/select.model';
import { IDtoRequisitionFilter } from 'app/shared/models/opening/dto-requisition-filter.model';
import { IDtoPosition } from 'app/shared/models/opening/dto-position.model';
import { IDtoCalculateSalary } from 'app/shared/models/position/dto-calculate-salary.model';
import { IDtoWorkingDay } from 'app/shared/models/position/dto-working-day.model';
import { IDtoRequisitionPosition } from 'app/shared/models/opening/dto-requisition-position.model';
import { IDtoRequisitionTracking } from 'app/shared/models/opening/dto-requisition-tracking.model';

@Injectable()
export class OpeningService {
    private openingUrl = '';
    private requestUrl = '';
    private recruitmentUrl = '';
    private quoteUrl = '';
    constructor(private service: DataService
        , private configurationService: ConfigurationService) {
        if (this.configurationService.isReady) {
            this.openingUrl = this.configurationService.serverSettings.openingUrl;
            this.requestUrl = this.configurationService.serverSettings.requestUrl;
            this.recruitmentUrl = this.configurationService.serverSettings.recruitmentUrl;
            this.quoteUrl = this.configurationService.serverSettings.quoteUrl;
        } else {
            this.configurationService.settingsLoaded$.subscribe(x => {
                this.openingUrl = this.configurationService.serverSettings.openingUrl;
                this.requestUrl = this.configurationService.serverSettings.requestUrl;
                this.recruitmentUrl = this.configurationService.serverSettings.recruitmentUrl;
                this.quoteUrl = this.configurationService.serverSettings.quoteUrl;
            });
        }
    }
    /**Información de requisiciones */
    public addRequisition(data: IDtoRequisition): Observable<IResult> {
        const url = `${this.openingUrl}api/Requisitions`;
        return this.service.post(url, data).pipe(map((response: any) => {
            return response;
        }));
    }
    public updateRequisition(data: IDtoRequisition): Observable<IResult> {
        const url = `${this.openingUrl}api/Requisitions`;
        return this.service.putWithId(url, data).pipe(map((response: any) => {
            return response;
        }));
    }
    public getPositionById(positionId: number): Observable<IResult> {
        const url = `${this.openingUrl}api/Positions/GetRequisitionById?id=${positionId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getRequisitionByFilter(data: IDtoRequisitionFilter): Observable<IResult> {
        const url = `${this.openingUrl}api/Requisitions/GetRequisitionByFilter`;
        return this.service.post(url, data).pipe(map((response: any) => {
            return response;
        }));
    }
    public getCatalogStatusRequests(): Observable<ISelect[]> {
        const url = this.openingUrl + 'api/statusRequests/getCatalogStatusRequests/';
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getcatalogFulfillments(): Observable<ISelect[]> {
        const url = this.openingUrl + 'api/fulfillments/getCatalogFulfillments/';
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogMotiveVacancys(): Observable<ISelect[]> {
        const url = this.openingUrl + 'api/motiveVacancies/getCatalogMotiveVacancies/';
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogRequisitions(): Observable<IResult> {
        const url = `${this.openingUrl}api/Requisitions`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogRequisitionsByTrademarkId(trademarkId: number): Observable<IResult> {
        const url = `${this.openingUrl}api/Requisitions/getRequisitionsByTrademarkId?trademarkId=${trademarkId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogContractTypes(): Observable<ISelect[]> {
        const url = `${this.requestUrl}api/ContractType/getCatalogContractTypes/`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogListEmployeeActive(): Observable<ISelect[]> {
        const url = `${this.requestUrl}api/Employees/getCatalogListEmployeeActive/`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogPayrollOfficers(): Observable<ISelect[]> {
        const url = `${this.openingUrl}api/PayrollManagers/getCatalogPayrollManagers/`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCurrentDate(): Observable<Date> {
        const url = `${this.requestUrl}api/Dismissals/getCurrentDate/`;
        return this.service.get(url).pipe(map((response: any) => {
            return response;
        }));
    }
    public cancelPosition(data: IDtoPosition): Observable<IResult> {
        const url = `${this.openingUrl}api/Positions/cancelPosition`;
        return this.service.post(url, data).pipe(map((response: any) => {
            return response;
        }));
    }
    public pausedPosition(data: IDtoPosition): Observable<IResult> {
        const url = `${this.openingUrl}api/Positions/pausedPosition`;
        return this.service.post(url, data).pipe(map((response: any) => {
            return response;
        }));
    }
    public getEmployeeByRequisitionId(requisitionId: string): Observable<ISelect> {
        const url = `${this.recruitmentUrl}api/Employees/getEmployeeByRequisitionId?requisitionId=${requisitionId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getPaymentConceptsForOpening(jobId: number): Observable<IResult> {
        const url = `${this.quoteUrl}api/Positions/getPaymentConceptsForOpening?jobId=${jobId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogSupervisors(): Observable<ISelect[]> {
        const url = `${this.openingUrl}api/Supervisors/getCatalogSupervisors/`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getWorkingDay(id: number): Observable<IResult> {
        const url = `${this.quoteUrl}api/WorkingDays/getWorkingDay?id=${id}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getRequisitionByPositionId(requisitionId: number): Observable<IDtoRequisitionPosition> {
        const url = `${this.openingUrl}api/Requisitions/getRequisitionByPositionId`;
        return this.service.post(url, requisitionId)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public updateSupervisor(data: IDtoRequisition): Observable<IResult> {
        const url = `${this.openingUrl}api/Requisitions/updateSupervisor`;
        return this.service.putWithId(url, data).pipe(map((response: any) => {
            return response;
        }));
    }
    public updateCoordinator(data: IDtoRequisition): Observable<IResult> {
      const url = `${this.openingUrl}api/Requisitions/updateCoordinator`;
      return this.service.putWithId(url, data).pipe(map((response: any) => {
          return response;
      }));
  }
    public getCatalogStoreRoutes(): Observable<ISelect[]> {
        const url = `${this.openingUrl}api/StoreRoutes/getCatalogStoreRoutes/`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public addRequisitionTracking(data: IDtoRequisitionTracking): Observable<IResult> {
        const url = `${this.openingUrl}api/RequisitionTrackings/addRequisitionTracking`;
        return this.service.post(url, data).pipe(map((response: any) => {
            return response;
        }));
    }
    public deleteRequisitionTracking(id: number): Observable<IResult> {
        const url = `${this.openingUrl}api/RequisitionTrackings/deleteRequisitionTracking?id=${id}`;
        return this.service.delete(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getRequisitionTrackingsByRequisitionId(requisitionId: number): Observable<IDtoRequisitionTracking[]> {
        const url = `${this.openingUrl}api/RequisitionTrackings/getRequisitionTrackingsByRequisitionId?requisitionId=${requisitionId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public updateRequisitionTracking(dto: IDtoRequisitionTracking): Observable<IResult> {
        const url = `${this.openingUrl}api/RequisitionTrackings/updateRequisitionTracking`;
        return this.service.putWithId(url, dto).pipe(map((response: any) => {
            return response;
        }));
    }
    public updateOperationObservationRequisitionTracking(dto: IDtoRequisitionTracking): Observable<IResult> {
        const url = `${this.openingUrl}api/RequisitionTrackings/updateOperationObservationRequisitionTracking`;
        return this.service.putWithId(url, dto).pipe(map((response: any) => {
            return response;
        }));
    }
    public getRequisitionById(requisitionId: number): Observable<IDtoRequisition> {
        const url = `${this.openingUrl}api/Requisitions/getRequisitionById?requisitionId=${requisitionId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
}
